<template>
  <div id="kebai-login">
    <div class="page-login-bg">
      <div class="container">
        <!-- <div id="particles-js"></div> -->
        <canvas id="particles-js"></canvas>
      </div>
    </div>
    <div class="page-main-container">
      <div class="page-left-container">
        <div class="center-image">
          <img class="box-rotate" src="~@/assets/images/login-left-img.png" />
        </div>
      </div>
      <div class="page-login-card">
        <div class="page-login-box">
          <div class="head">
            <div class="image">
              <img src="~@/assets/images/logo-img.png" alt="管理系统" />
            </div>
            <div class="image-desc">科百物联网数据管理系统</div>
          </div>
          <div
            style="margin-top: 36px"
            class="inputbox kebai-icons-user icon-middle"
          >
            <input
              v-model="model.username"
              autocomplete="off"
              placeholder="输入账号"
              class="username full"
              type="text"
            />
          </div>
          <div class="inputbox kebai-icons-lock icon-middle">
            <input
              v-model="model.password"
              autocomplete="off"
              placeholder="输入密码"
              class="password full"
              type="password"
            />
          </div>
          <div class="inputbox kebai-icons-vcode icon-middle">
            <input
              v-model="model.code"
              autocomplete="off"
              placeholder="输入验证码"
              class="code"
              style="width: 60%"
              type="text"
            />
            <img
              @click="newCodeImage"
              :src="codeImageUrl"
              style="cursor: pointer; width: 35%; margin-left: 20px"
            />
          </div>
          <div class="btn-group help-button">
            <span class="inputbox rememberme">
              <label for="rememberme">
                <input
                  type="checkbox"
                  v-model="model.rmb"
                  style="cursor: pointer"
                  id="rememberme"
                />
                记住密码
              </label>
            </span>
            <span
              @click="clickForgetPassword"
              style="cursor: pointer"
              class="inputbox forget"
              >忘记密码?</span
            >
          </div>
          <div class="inputbox">
            <input
              @click="submitClick"
              class="button button-login submit full"
              value="登录"
              type="button"
            />
          </div>
          <!-- <div class="btn-group download">
            <span class="inputbox">
              <input
                name="android-download"
                @click="clickDownload(0)"
                :class="`button ${qrcodeStatus.qrcode0 ? 'active' : ''}`"
                type="button"
                value="Android下载"
              />
            </span>
            <span class="inputbox">
              <input
                name="ios-download"
                @click="clickDownload(1)"
                :class="`button ${qrcodeStatus.qrcode1 ? 'active' : ''}`"
                type="button"
                value="iOS下载"
              />
            </span>
          </div> -->
          <!-- <div class="qrcodebox">
            <span
              :class="`qrcode qrcode-0 ${qrcodeStatus.qrcode0 ? '' : 'hide'}`"
            >
              <img
                class="image"
                src="~@/assets/images/qr-code-android.png"
                alt="Android"
              />
            </span>
            <span
              :class="`qrcode qrcode-1 ${qrcodeStatus.qrcode1 ? '' : 'hide'}`"
            >
              <img
                class="image"
                src="~@/assets/images/qr-code-ios.png"
                alt="iOS"
              />
            </span>
          </div> -->
        </div>
      </div>
    </div>
    <transition
      enter-active-class="fadeInDown"
      leave-active-class="fadeOutUp"
      :duration="{ enter: 1000, leave: 1000 }"
    >
      <div v-if="showMessage" :class="`dialog-forget-help ${showMessageType}`">
        <div class="help-text">{{ showMessage }}</div>
      </div>
    </transition>
  </div>
</template>

<script>
import ApiRequest from "./api-login";
import background from "./background";
import { Base64 } from "js-base64";
export default {
  data() {
    return {
      apiReq: new ApiRequest(this),
      model: {
        captchaKey: new Date().getTime(),
        username: null,
        password: null,
        code: null,
        rmb: false,
        // Authorization: Base64.encode("modelwf:modelwf"),
        Authorization: Base64.encode("daping:daping"),
      },
      codeImageUrl: "",
      qrcodeStatus: {
        qrcode0: true,
        qrcode1: false,
      },
      showMessage: null, //请拨打客服电话:010-62127261
      showMessageType: 0,
    };
  },
  mounted() {
    // window.loading(false);
    background();
    this.newCodeImage();

    setTimeout(() => {
      this.model.rmb = !!this.getStorage("rmbUser");
      if (this.model.rmb === true) {
        var username = this.getStorage("Username");
        var password = this.getStorage("Password");
        if (password && username) {
          this.model.username = username;
          this.model.password = Base64.decode(password);
        }
      } else {
        this.model.username = null;
        this.model.password = null;
      }
    }, 1000);

    document.onkeydown = (e) => {
      let event = e || window.event;
      let key = event.keyCode;
      if (key == 13) {
        this.submitClick();
      }
    };
  },
  methods: {
    submitClick() {
      if (
        this.model.username == null ||
        this.model.username.replace(/\s/g, "") == ""
      ) {
        this.showTips("请输入用户名", "warning");
        return;
      }
      if (
        this.model.password == null ||
        this.model.password.replace(/\s/g, "") == ""
      ) {
        this.showTips("请输入密码", "warning");
        return;
      }
      if (this.model.code == null || this.model.code.replace(/\s/g, "") == "") {
        this.showTips("请输入验证码", "warning");
        return;
      }
      let { username, password, code, captchaKey, Authorization } = this.model;
      this.doLogin({
        username,
        password,
        code,
        Authorization,
        key: captchaKey,
      });
    },
    doLogin(data) {
      // window.loading(true);
      this.apiReq
        .doLogin(data)
        .then((result) => {
          // window.loading(false);
          let data = result.data;
          this.$localStorage.set("expires_in", data.expires_in);
          this.$localStorage.set("access_token", data.access_token);
          this.$localStorage.set("refresh_token", data.refresh_token);

          this.setStorage("Username", this.model.username, 7);

          if (this.model.rmb === true) {
            this.setStorage("rmbUser", "true", 7);
            this.setStorage("Password", Base64.encode(this.model.password), 7);
            this.setStorage("userType", data.role, 7);
          } else {
            this.delStorage("userinfo");
            this.delStorage("rmbUser");
            this.delStorage("Password");
            this.setStorage("userType", data.role, 7);
          }
          window.location.href = "/cloud/main.html";
          // window.location.href = window.prePath + "/cloud/main.html";
          this.getUserInfo();
        })
        .catch((error) => {
          var msg = error.response.data;
          // window.loading(false);
          this.showTips(msg.message, "error");
          this.newCodeImage();
          console.log("服务端错误", error);
        });
    },
    getUserInfo() {},
    delStorage(key) {
      this.$localStorage.remove(key);
    },
    getStorage(key) {
      return this.$localStorage.get(key);
    },
    setStorage(key, value, expire) {
      if (key && value) {
        this.$localStorage.set(key, value);
      }
    },
    newCodeImage() {
      this.model.code = null;
      this.apiReq
        .getCaptcha(this.model.captchaKey)
        .then((res) => {
          let base64 = btoa(
            new Uint8Array(res.data).reduce(function (data, byte) {
              return data + String.fromCharCode(byte);
            }, "")
          );
          return base64;
        })
        .then((res) => {
          this.codeImageUrl = "data:image/png;base64," + res;
        });
    },
    clickForgetPassword() {
      this.showTips("请拨打客服电话:010-62127261", "info");
    },
    showTips(msg, type) {
      this.$message({ type: type, message: msg });
    },
  },
};
</script>

<style lang="scss">
@import "./main.scss";
.inputbox {
  /deep/.el-checkbox__inner {
    background-color: rgba(0, 0, 0, 0.1);
    border: 1px solid #ffffff;
  }
  /deep/.el-checkbox__label {
    color: #ffffff;
  }
  /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: rgba(0, 0, 0, 0.1);
    border-color: #ffffff;
  }
  /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
    color: #ffffff;
  }
}
</style>